export function routes($stateProvider) {
    $stateProvider
        .state('app.pad.pendentes', {
        url: '/pendentes',
        abstract: true,
        template: '<div ui-view></div>'
    })
        .state('app.pad.pendentes.list', {
        url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
        title: 'Processos Pendentes',
        template: require('./directory/directory.view.html'),
        controller: 'PadPendentesListController',
        controllerAs: 'vm',
        role: '$internal',
        params: {
            state: {
                value: 1,
                dynamic: true
            },
            page: {
                value: 1,
                dynamic: true
            },
            items: {
                value: 20,
                dynamic: true
            },
            order: {
                value: "id",
                dynamic: true
            },
            sort: {
                value: "asc",
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.pad.pendentes.details', {
        url: '/{id}',
        title: 'Linha de Processo',
        controller: 'PadPendentesDetailsController',
        controllerAs: 'vm',
        template: require('./details/details.view.html'),
        role: '$internal',
    });
}
routes.$inject = ['$stateProvider'];
